import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CanActivate } from "@angular/router";
import { LoginService } from "../api/auth/login.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: LoginService, private router: Router) {}

  canActivate() {
    // If the user is not logged in we'll send them back to the home page
    if (!this.authService.isAuthenticated()) {
      // console.log("No estás logueado");
      this.router.navigate(["/login"]);
      return false;
    }
    // console.log("SIII ESTAS LOGUEAD");
    return true;
  }
}